'use strict';

angular.module('cimerFrontEndApp').service('Discipline',['$q','$http','ApiUrl',
  function($q,$http,ApiUrl) {
    var _apiUrl=ApiUrl.url('/Discipline/');

    return {
      getDisciplines: function() {
        var deferred = $q.defer();
        var self=this;

        var data= {
          cache:true
        };

        $http.get(_apiUrl + 'GetOptions',data).then(function (response){
          self.disciplines=response.data;
          deferred.resolve();
        }, function (err) {
          self.disciplines=null;
          deferred.reject(err);
        });

        return deferred.promise;
      },
      disciplines: null
    };
  }]);
